import { make } from 'vuex-pathify';

const state = {
  siteId: null,
  feedId: null,
  sorting: 'most-recent',
  searchCount: 0,
  selectedTags: [],
  selectedTagsForRequest: '',
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations,
};
